import { LogsState } from "../state";
import type { GotLog }  from "@/models/logs";
import { gql } from "graphql-tag"
import { ActionContext } from "vuex";
import type { RootState } from "@/store/types";
import apolloClient from "@/apollo";

const getLogQuery = gql`
  query getLog ($input: GetLog){
    getLog(input: $input){
        ... on GotLog {
            log {
                attributes{
                    key
                    value
                }
                body
                id
                language
                libraryName
                libraryVersion
                # resource
                resourceAttributes{
                    key
                    value
                }
                serviceInstanceId
                serviceName
                serviceNamespace
                serviceVersion
                severity
                severityNumber
                spanId
                timestamp
                # traceFlags
                traceId
            }
        }
    ... on Corollary {
        code
        message
    }
    }
}
`;

/**
 * Executes the query `getLog` and assigns the Log value.
 *
 * @param context - Context where the action is being taking place.
 * @param args - Arguments object containing the required parameters.
 * @param args.filename - Encoded filename string of the current Log.
 * @param args.logId - Log ID of the current Log.
 * @returns It doesn't return anything on success, but if an error occurred, then it returns
 *    the error with the Log id.
 */
export async function getDetailedLog  (
    context: ActionContext<LogsState, RootState>,
    args: { filename: string; logId: string }
): Promise<void> {
    const result = await apolloClient.query({
        query: getLogQuery,
        variables: {
            input: {
                filename: args.filename,
                logId: args.logId,
            },
        },
        fetchPolicy: "no-cache",
    });
    const typeName = result.data.getLog.__typename
    if (typeName === "GotLog") {
        const gotLog: GotLog = result.data.getLog;
        context.commit("setLog", gotLog.log);
    }
    else {
        context.commit("setLog", undefined);
    }
}
